/**
  * @author Ryan Gladstone, Brendan Magee
  */

function timezoneService($translate, moment, $http, $log) {
  const service = {};
  const globalSettingsUrl = '/settings-readonly/api';
  const defaultTimezone = 'America/New_York';

  service.timezones = [
    {
      id: 'America/Anchorage',
      name: $translate.instant('TIMEZONES.ANCHORAGE')
    },
    {
      id: 'America/Los_Angeles',
      name: $translate.instant('TIMEZONES.LOS_ANGELES')
    },
    { id: 'America/Denver', name: $translate.instant('TIMEZONES.DENVER') },
    { id: 'America/Chicago', name: $translate.instant('TIMEZONES.CHICAGO') },
    {
      id: 'America/Costa_Rica',
      name: $translate.instant('TIMEZONES.COSTA_RICA')
    },
    { id: 'America/New_York', name: $translate.instant('TIMEZONES.NEW_YORK') },
    { id: 'America/Toronto', name: $translate.instant('TIMEZONES.TORONTO') },
    {
      id: 'America/Sao_Paulo',
      name: $translate.instant('TIMEZONES.SAO_PAOLO')
    },
    { id: 'Europe/Berlin', name: $translate.instant('TIMEZONES.BERLIN') },
    { id: 'Europe/London', name: $translate.instant('TIMEZONES.LONDON') },
    { id: 'Europe/Paris', name: $translate.instant('TIMEZONES.PARIS') },
    { id: 'Europe/Istanbul', name: $translate.instant('TIMEZONES.ISTANBUL') },
    { id: 'Europe/Moscow', name: $translate.instant('TIMEZONES.MOSCOW') },
    { id: 'Asia/Calcutta', name: $translate.instant('TIMEZONES.CALCUTTA') },
    { id: 'Asia/Shanghai', name: $translate.instant('TIMEZONES.SHANGHAI') },
    { id: 'Asia/Tokyo', name: $translate.instant('TIMEZONES.TOKYO') },
    { id: 'Australia/Sydney', name: $translate.instant('TIMEZONES.SYDNEY') },
    { id: 'Pacific/Auckland', name: $translate.instant('TIMEZONES.AUCKLAND') }
  ];

  service.userTimezone = moment.tz.guess() || defaultTimezone;
  service.userTimeHourFormat = 12;

  service.getTzDate = (dateValue) =>
    new Date(
      new Date(dateValue).toLocaleString('en-US', {
        timeZone: service.userTimezone
      })
    );

  service.isRelativeDate = (value) => {
    if (!value || typeof value !== 'string') {
      return false;
    }
    return value.startsWith('+') || value.startsWith('-');
  };

  service.isFromQuickPick = (time) =>
    time === 'now' ||
    time === 'today' ||
    time === 'yesterday' ||
    time === 'tomorrow';

  service.getRelativeDate = (relativeVal) => {
    const date = service.getTzDate(new Date());
    const relativeValue = parseInt(relativeVal, 10) * 1000;
    return date.getTime() + relativeValue;
  };

  service.getTzDiffDate = (date) => {
    const localDate = new Date(date);
    const tzDate = new Date(
      localDate.toLocaleString('en-US', {
        timeZone: service.userTimezone
      })
    );

    const diff = localDate.getTime() - tzDate.getTime();
    return new Date(localDate.getTime() + diff).getTime();
  };

  service.getTimezoneDisplay = (timezone) => {
    const existingTimezone = service.timezones.find((tz) => tz.id === timezone);

    return existingTimezone ? existingTimezone.name : timezone;
  };

  service.getUTCOffset = (timezone) => {
    const offset = moment.tz.zone(timezone).utcOffset(Date.now());
    const offsetHours = offset / -60;
    const offsetMinutes = Math.abs(offset % 60);
    return `${offsetHours > 0 ? '+' : ''}${
      offsetHours < 10 ? '0' : ''
    }${offsetHours}:${offsetMinutes < 10 ? 0 : ''}${offsetMinutes}`;
  };

  service.getStatsUTCOffset = (timezone) => {
    let offset = (
      moment.tz.zone(timezone).utcOffset(Date.now())
    ).toString();

    if (offset >= 0) {
      offset = `+${offset}m`;
    } else if (offset < 0) {
      offset += 'm';
    }

    return offset;
  };

  service.init = async () => {
    try {
      const response = await $http.get(
        `${globalSettingsUrl}/v1/organization/timezone/`
      );

      service.globalSettingsConfig = response.data;
      if (response.data.timezone) {
        service.userTimezone = response.data.timezone;
      }

      if (response.data.timeHourFormat) {
        service.userTimeHourFormat = response.data.timeHourFormat;
      }

      service.userUTCOffset = service.getUTCOffset(service.userTimezone);
      service.userStatsOffset = service.getStatsUTCOffset(service.userTimezone);
    } catch (error) {
      $log.error(error);
    }
  };

  return service;
}

const arr = ['$translate', 'moment', '$http', '$log', timezoneService];

module.exports = (ngModule) => {
  ngModule.factory('timezoneService', arr);
};
